.popupMenu {
    position: absolute;
    bottom: 12px;
    left: 12px;
    width: 200px;
    border-radius: 4px;
    box-shadow: 0px 2px 6px rgba(8,8,40, 0.1);
    z-index: 9999;

    &.smallContainer {
        width: auto;
        box-sizing: border-box;
    }

    li {
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 15px 12px;
        background-color: white;

        &:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        &:last-child {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }

        &.small {
            gap: 12px;
            width: 80px;

            &:hover {
                background-color: rgba(241, 244, 255, 1);
            }

            .icon {
                margin: 0;
            }
        }

        &:last-child {
            border-top: 1px solid #e8e9ed;;
        }
    }
}

.icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 12px;

    img.logo {
        width: 32px;
        height: 32px;
    }
}